import * as React from "react";

import { cn } from "../../utils";

type DrgFindingCardComponent = React.FC<React.ComponentProps<"div">> & {
  Header: typeof DrgFindingCardHeader;
  Title: typeof DrgFindingCardTitle;
  HeaderAction: typeof DrgFindingCardHeaderAction;
  Content: typeof DrgFindingCardContent;
  Details: typeof DrgFindingCardDetails;
  Description: typeof DrgFindingCardDescription;
  Footer: typeof DrgFindingCardFooter;
  Meta: typeof DrgFindingCardMeta;
  Actions: typeof DrgFindingCardActions;
};

function DrgFindingCardRoot({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-w-full af-overflow-hidden af-rounded-md af-border af-border-interface-border af-bg-card af-shadow",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardRoot.displayName = "DrgFindingCard";

function DrgFindingCardHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-flex af-h-8 af-items-start af-justify-between af-gap-2 af-px-4 af-pt-2",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardHeader.displayName = "DrgFindingCard.Header";

function DrgFindingCardTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-min-w-0 af-flex-1 af-truncate af-text-sm af-font-medium af-leading-5 af-text-foreground",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardTitle.displayName = "DrgFindingCard.Title";

function DrgFindingCardHeaderAction({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("af-flex af-shrink-0 af-items-center", className)}
      {...props}
    />
  );
}
DrgFindingCardHeaderAction.displayName = "DrgFindingCard.HeaderAction";

function DrgFindingCardContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("af-flex af-min-w-0 af-flex-col", className)}
      {...props}
    />
  );
}
DrgFindingCardContent.displayName = "DrgFindingCard.Content";

function DrgFindingCardDetails({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-border-t af-border-interface-border af-px-4 af-py-2",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardDetails.displayName = "DrgFindingCard.Details";

function DrgFindingCardDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-whitespace-pre-wrap af-break-words af-px-4 af-pb-3 af-pt-2 af-text-sm af-leading-5 af-text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardDescription.displayName = "DrgFindingCard.Description";

function DrgFindingCardFooter({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-flex af-min-h-10 af-items-center af-justify-between af-gap-3 af-border-t af-border-interface-border af-px-4 af-py-2",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardFooter.displayName = "DrgFindingCard.Footer";

function DrgFindingCardMeta({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-flex af-min-w-0 af-items-center af-gap-1.5 af-truncate af-text-xs af-leading-4 af-text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardMeta.displayName = "DrgFindingCard.Meta";

function DrgFindingCardActions({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "af-ml-auto af-flex af-shrink-0 af-items-center af-gap-1",
        className,
      )}
      {...props}
    />
  );
}
DrgFindingCardActions.displayName = "DrgFindingCard.Actions";

const DrgFindingCard = DrgFindingCardRoot as DrgFindingCardComponent;

DrgFindingCard.Header = DrgFindingCardHeader;
DrgFindingCard.Title = DrgFindingCardTitle;
DrgFindingCard.HeaderAction = DrgFindingCardHeaderAction;
DrgFindingCard.Content = DrgFindingCardContent;
DrgFindingCard.Details = DrgFindingCardDetails;
DrgFindingCard.Description = DrgFindingCardDescription;
DrgFindingCard.Footer = DrgFindingCardFooter;
DrgFindingCard.Meta = DrgFindingCardMeta;
DrgFindingCard.Actions = DrgFindingCardActions;

export { DrgFindingCard };
